const ResponsePeriodType = Object.freeze({
    ANSWER_PERIOD: { value: 'answer_period', text: 'Answer Period' },
    FREE_CHOICE_OF_PERIOD: { value: 'free_choice_of_period', text: 'Free Choice Of Period' },
});

export default ResponsePeriodType;
